import f from "./index515.js";
import { resolveComponent as o, createBlock as n, openBlock as r, Transition as h, withCtx as a, createElementBlock as l, createCommentVNode as t, createElementVNode as c, createVNode as d, toDisplayString as s, Fragment as k, createTextVNode as i } from "vue";
/* empty css         */
import y from "./index231.js";
const g = ["data-component"], _ = { class: "flex gap-8 mb-8 screen-m:mb-0 screen-m:w-full screen-m:items-center" }, b = { class: "mr-8 text-text-l screen-m:mr-16" }, v = {
  key: 0,
  class: "mb-4 font-bold"
};
function C(e, w, S, V, $, N) {
  const u = o("survey-svg"), m = o("cs-primary-button"), p = o("ms-close");
  return r(), n(h, { name: "sticky" }, {
    default: a(() => [
      e.isVisible ? (r(), l("div", {
        key: 0,
        "data-component": e.$options.name,
        class: "p-16 bg-white border border-solid border-color-neutral-grey-10 custom-positioning custom-shadow z-overlay-canvas rounded-t-10 screen-m:rounded-b-10 screen-m:flex screen-m:h-80 screen-m:py-8 screen-m:px-16 custom-w-max"
      }, [
        c("div", _, [
          d(u, { class: "self-center flex-shrink-0 w-64 h-64 mr-16" }),
          c("div", b, [
            e.headline ? (r(), l("div", v, s(e.headline), 1)) : t("", !0),
            e.text ? (r(), l(k, { key: 1 }, [
              i(s(e.text), 1)
            ], 64)) : t("", !0)
          ]),
          e.isScreenM ? (r(), n(m, {
            key: 0,
            href: e.href,
            target: e.target,
            rel: e.rel,
            isCentered: "",
            isSmall: "",
            class: "screen-m:ml-auto"
          }, {
            default: a(() => [
              i(s(e.linkText), 1)
            ]),
            _: 1
          }, 8, ["href", "target", "rel"])) : t("", !0),
          d(p, {
            class: "flex-shrink-0 w-24 h-24 ml-auto cursor-pointer screen-m:ml-24 justify-self-end",
            onClick: e.onClick
          }, null, 8, ["onClick"])
        ]),
        e.isScreenM ? t("", !0) : (r(), n(m, {
          key: 0,
          href: e.href,
          target: e.target,
          rel: e.rel,
          isCentered: "",
          isSmall: ""
        }, {
          default: a(() => [
            i(s(e.linkText), 1)
          ]),
          _: 1
        }, 8, ["href", "target", "rel"]))
      ], 8, g)) : t("", !0)
    ]),
    _: 1
  });
}
const j = /* @__PURE__ */ y(f, [["render", C], ["__scopeId", "data-v-9baad514"]]);
export {
  j as default
};
